import request from '@/router/axios'

export function getActivityLecturerStatisticsSummaryData (query) {
  return request({
    url: '/activity/admin/activity/projects/lecturer/analysis/summary',
    method: 'get',
    params: query,
  })
}

export function getActivitySubLobStatisticsSummaryData (query) {
  return request({
    url: '/activity/admin/activity/projects/subLob/analysis/summary',
    method: 'get',
    params: query,
  })
}

export function exportActivityLecturerStatisticsSummaryData (param) {
  return request({
    url: '/activity/admin/activity/projects/lecturer/analysis/summary/export',
    method: 'get',
    params: param,
  })
}

export function exportActivitySubLobStatisticsSummaryData (param) {
  return request({
    url: '/activity/admin/activity/projects/subLob/analysis/summary/export',
    method: 'get',
    params: param,
  })
}